module.exports = __webpack_public_path__ + "static/working3-d46aa0e2be73f0099fc64ba9513f81cf.png";